import React, { useState, useEffect } from 'react';

import OrganizationBanner from '../../components/OrganizationBanner/OrganizationBanner';
import Carousel from '../../components/Carousel/Carousel';
import WomensSection from '../../components/WomensSection/WomensSection';
import Footer from '../../components/Footer/Footer';
import { fetchHomeSections } from '../../services/api';
import './Home.css';

const Home = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch dynamic sections from API
  useEffect(() => {
    const loadSections = async () => {
      try {
        setLoading(true);
        const apiSections = await fetchHomeSections();
        
        if (apiSections && apiSections.length > 0) {
          // Transform API response to section format
          // Expected format: [{ id, title: {EN, KU, AR, TR}, images: [{id, url, alt}], sectionId, order }]
          const transformedSections = apiSections.map(section => ({
            id: section.id || section.sectionId || `section-${Math.random()}`,
            title: section.title || {
              EN: section.name || 'Section',
              KU: section.name || 'بەش',
              AR: section.name || 'قسم',
              TR: section.name || 'Bölüm'
            },
            images: section.images || [],
            sectionId: section.sectionId || section.id || `section-${Math.random()}`,
            order: section.order || 0
          })).sort((a, b) => (a.order || 0) - (b.order || 0));
          
          setSections(transformedSections);
        } else {
          // No sections from API - set empty array
          setSections([]);
        }
      } catch (error) {
        console.error('Failed to load home sections:', error);
        // On error, set empty array (no fallback)
        setSections([]);
      } finally {
        setLoading(false);
      }
    };

    loadSections();
  }, []);

  return (
    <div className="home-page">
      <div className="container organization-banner-container">
        <OrganizationBanner />
      </div>

      <div className="home-carousel-section">
        <Carousel />
      </div>

      {loading ? (
        <div className="container">
          <div className="loading-message" style={{ padding: '2rem', textAlign: 'center' }}>Loading sections...</div>
        </div>
      ) : sections.length === 0 ? (
        <div className="container">
          <div className="no-content-message" style={{ padding: '2rem', textAlign: 'center' }}>No sections found.</div>
        </div>
      ) : (
        sections.map((section) => (
          <WomensSection 
            key={section.id}
            title={section.title}
            images={section.images}
            sectionId={section.sectionId}
          />
        ))
      )}

      <Footer />
    </div>
  );
};

export default Home;
